import React, { useState, useEffect, useCallback } from 'react';
import TableManager from '../data/TableManager';
import { FaTimes } from 'react-icons/fa';

// CONFIGURAZIONE COLONNE: Basata sulla DDL SKE_DocumentazioneWeb
const dowColumnConfig = [
  // Fields not shown in forms or table (visibility 0) 
  "DOW_Id_DocumentazioneWeb=0,ID",
  "DOW_IdRif_DocumentazioneWeb=0,ID Rif.",
  
  // IMPORTANTE: Campo collegamento alla macro funzione (nascosto)
  "DOW_Id_MacroFunzioni=0,ID Macro Funzione", 
  
  // General form fields (visibility 2 = form + tabella)
  "DOW_DescrizioneLink=2,Descrizione Link,required", 
  "DOW_Link=2,Link,required", 
  
  // System fields (visibility 0 = nascosti ma gestiti dal backend)
  "DOW_InizioValidita=0,Inizio Validità,type=datetime", 
  "DOW_FineValidita=0,Fine Validità,type=datetime", 
  "DOW_StatiRecord=0,Stato Record", 

  // Audit fields (visibility 0 = nascosti, gestiti dal backend)
  "DOW_UtenteInserimento=0,Utente Inserimento",
  "DOW_DataOraInserimento=0,Data/Ora Inserimento",
  "DOW_TerminaleInserimento=0,Terminale Inserimento",
  "DOW_UtenteModifica=0,Utente Modifica",
  "DOW_DataOraModifica=0,Data/Ora Modifica",
  "DOW_TerminaleModifica=0,Terminale Modifica",
  "DOW_Utente=0,Utente Audit",
  "DOW_Terminale=0,Terminale Audit",
  "DOW_Timestamp=0,Timestamp DB",
];

// CONFIGURAZIONE LAYOUT
const dowFormLayoutConfig = {
  sections: [
    {
      title: "Dettagli Link",
      fields: ["DOW_DescrizioneLink", "DOW_Link"]
    }
  ]
};

const dowInputTypes = {
  DOW_DescrizioneLink: 'textarea',
  DOW_Link: 'text',
};

const filterConfig = [];

/**
 * DocumentazioneWebModal - Modal per gestire i link di documentazione web
 * collegati a una macro funzione specifica
 */
const DocumentazioneWebModal = ({ 
  isOpen, 
  onClose, 
  macroFunzioneId,
  macroFunzioneNome,
  onDataChanged 
}) => {
  const [initialFilters, setInitialFilters] = useState({});
  const [defaultValues, setDefaultValues] = useState({});

  useEffect(() => {
    if (isOpen && macroFunzioneId) {
      setInitialFilters({ DOW_Id_MacroFunzioni: macroFunzioneId });
      setDefaultValues({ DOW_Id_MacroFunzioni: macroFunzioneId });
    }
  }, [isOpen, macroFunzioneId]);

  const handleCrudOperation = useCallback(() => {
    if (onDataChanged) {
      onDataChanged();
    }
  }, [onDataChanged]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 bg-blue-600 dark:bg-blue-800 border-b border-gray-300 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-white">
            Documentazione Web - {macroFunzioneNome || `Macro Funzione ${macroFunzioneId}`}
          </h3>
          <button 
            onClick={onClose}
            className="text-white hover:text-gray-200 transition-colors"
          >
            <FaTimes className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-grow overflow-auto p-6">
          <TableManager
            tableName="SKE_DocumentazioneWeb"
            primaryKey="DOW_Id_DocumentazioneWeb"
            pageTitle="Link Documentazione"
            columnConfig={dowColumnConfig}
            filterConfig={filterConfig}
            inputTypes={dowInputTypes}
            lookupConfig={{}}
            enableCreate={true}
            enableEdit={true}
            enableDelete={true}
            autoSearchOnLoad={false}
            initialFilters={initialFilters}
            autoSearchOnInitialFilters={true}
            defaultValuesForCreate={defaultValues}
            formLayoutConfig={dowFormLayoutConfig}
            onCreateSuccess={handleCrudOperation}
            onUpdateSuccess={handleCrudOperation}
            onDeleteSuccess={handleCrudOperation}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentazioneWebModal;
